import loginService from '../../../services/security/login.service';

const state ={
  userId:'',
  userLogin:'',
  userName:'',
  nameInstitution: '',
  password:'',
  token:null,
  tokenExpiration: null,
  isAuthenticated: false,
  accessValid: '',
  associatedAgencies: [],
  userEmail: '',
  delegatedUser: false,
  isLoginPage: false,
};

const getters={
  accessValid: state => {
    return state.accessValid;
  },
  userId: state =>{
    return state.userId;
  },
  userLogin: state => {
        return state.userLogin;
  },
  userName: state => {
      return state.userName;
  },
  nameInstitution: state=> {
    return state.nameInstitution;
  },
  isAuthenticated: state => {
        return state.isAuthenticated;
  },
  token: state => {
        return state.token;
  },
  tokenExpirationTime: state => {
    return state.tokenExpiration;
  },
  getAssociatedAgencies: state => {
    return state.associatedAgencies;
  },
  userEmail: state => {
    return state.userEmail;
  },
  delegatedUser: state => {
    return state.delegatedUser;
  },
  isLoginPage: state => {
    return state.isLoginPage;
  }

};

const mutations ={
    updateAccessValid: (state, accessValid) => {
        state.accessValid = accessValid;
        window.localStorage.setItem('accessValid', state.accessValid);
    },
    updateNameInstitution(state, name) {
        state.nameInstitution = name;
    },
    updateUserLogin(state, userLogin) {
      state.userLogin = userLogin;
    },
    updateUserName(state, userName){
      state.userName = userName;
    },
    updateAssociatedAgencies(state, associatedAgencies) {
      state.associatedAgencies = associatedAgencies;    
    },
    updateUserEmail(state, userEmail) {
      state.userEmail = userEmail;      
    },
    updateDelegatedUser(state, delegatedUser) {
      state.delegatedUser = delegatedUser;      
    },
    updateIsLoginPage(state, isLoginPage) {
      state.isLoginPage = isLoginPage;  
    },
    initApp(state) {
      state.accessValid = window.localStorage.getItem('accessValid') === 'true';
      state.token = window.localStorage.getItem('token') || null;
      state.userLogin = window.localStorage.getItem('userLogin') || '';
      state.userName = window.localStorage.getItem('userName') || '';
      state.nameInstitution = window.localStorage.getItem('nameInstitution') || '';
      state.associatedAgencies = convertStringToJson(window.localStorage.getItem('associatedAgencies')) || [];
      state.userEmail = window.localStorage.getItem('userEmail') || '';
      state.delegatedUser = window.localStorage.getItem('delegatedUser') || '';

      state.tokenExpiration = parseInt(
        window.localStorage.getItem('tokenExpiration')
      );
      const currentTime = new Date().getTime();
  
      state.isAuthenticated =
        state.token !== null && state.tokenExpiration - currentTime > 0;
    },
    login: (state, params)=> {
        state.userId = params.token.ID;
        state.userLogin = params.user;
        state.userName = params.token.Nome;
        state.nameInstitution = params.token.NomeInstituicao;
        state.token = params.token.access_token;
        state.isAuthenticated = true;
        state.accessValid = true;
        state.associatedAgencies = params.token.orgaosAssociados;
        state.userEmail = params.token.Email;
        state.delegatedUser = params.token.IndicadorOperadorDelegado;

        // persist user info into local store
        window.localStorage.setItem('isAuthenticated', true);
        window.localStorage.setItem('token', state.token);
        window.localStorage.setItem('userLogin', state.userLogin);
        window.localStorage.setItem('accessValid', state.accessValid);
        window.localStorage.setItem('userName', state.userName);
        window.localStorage.setItem('nameInstitution', state.nameInstitution);
        window.localStorage.setItem('associatedAgencies', JSON.stringify(state.associatedAgencies));
        window.localStorage.setItem('userEmail', state.userEmail);
        window.localStorage.setItem('delegatedUser', state.delegatedUser);

        const tokenExpiration = new Date();
        tokenExpiration.setSeconds(
          tokenExpiration.getSeconds() + parseInt(params.token.expires_in)
        );
        state.tokenExpiration = tokenExpiration;
        window.localStorage.setItem('tokenExpiration', tokenExpiration.getTime());
    },
    logout:(state)=> {
      state.userLogin='';
      state.userName = '';
      state.token=null;
      state.isAuthenticated = false;
      state.accessValid = false;
      state.tokenExpiration = '';
      state.listRequest = [];
      state.associatedAgencies = [];
      state.userEmail = '';
      state.delegatedUser = false;

      localStorage.clear();
  },   
};

function isJson(str){
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

function convertStringToJson(value){
  if (isJson(value))
    return JSON.parse(value);
  else
    return '';
}   


const actions={
  initApp({ commit }) {
    commit('initApp');
  },
  updateUserName({ commit }) {
    let userName = window.localStorage.getItem('userName');
    if (userName) {
         userStore.state.userName = userName || '';
         commit('updateUserName', userName);
    }
  },
  updateUserLogin({ commit }) {
    let userLogin = window.localStorage.getItem('userLogin');
    if (userLogin) {
         userStore.state.userLogin = userLogin || '';
         commit('updateUserLogin', userLogin);
    }
  },
  updateAssociatedAgencies({ commit }) {
    let associatedAgencies = window.localStorage.getItem('associatedAgencies');
    if (associatedAgencies) {
      userStore.state.associatedAgencies = convertStringToJson(associatedAgencies) || [];
      commit('updateAssociatedAgencies', convertStringToJson(associatedAgencies));
    }
  },
  updateUserEmail({ commit }) {
    let userEmail = window.localStorage.getItem('userEmail');
    if (userEmail) {
      userStore.state.userEmail = userEmail || '';
      commit('userEmail', userEmail);
    }
  },
  updateDelegatedUser({ commit }) {
    let delegatedUser = window.localStorage.getItem('delegatedUser');
    if (delegatedUser) {
      userStore.state.delegatedUser = delegatedUser || '';
      commit('delegatedUser', delegatedUser);
    }
  },
  setIsLoginPage: async({commit}, value) => {
    commit('updateIsLoginPage', value);
  },
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
            loginService
            .login({ username: credentials.username, password: credentials.password})
            .then(response => {
              if (response) {
                  commit('login', { token: response, user: credentials.username });
                  resolve(response);
                 } 
              })
              .catch(error => reject(error));
        });
    },
    logout({commit}){
        commit('logout');
    }
    
};

const userStore = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations

};

export default userStore;